import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Icon = ({
  name,
  color,
  className,
  size,
  ...rest
}) => (
  <span
    className={classNames(
      className,
      'icon',
      name ? `icon-${name}` : null,
      color,
      size ? `size-${size}` : null,

    )}
    focusable="false"
    aria-hidden="true"
    {...rest}
  />
);

Icon.propTypes = {
  color: PropTypes.oneOf(['error', 'success', 'warning', 'grey', 'primary', 'secondary', 'success-dark', 'grey-dark', 'warning-dark', 'error-dark']),
  size: PropTypes.oneOf(['inherit', 'small', 'regular', 'medium', 'large', 'exLarge']),
  className: PropTypes.string,
  name: PropTypes.string
};

Icon.defaultProps = {
  color: null,
  size: null,
  className: null,
  name: null
};

export { Icon };
